import ElementLocale from 'element-ui/lib/locale';
import elementLangZhCN from 'element-ui/lib/locale/lang/zh-CN';
import elementLangEn from 'element-ui/lib/locale/lang/en';
import zhCN from './messages/zh-CN';
import enUS from './messages/en-US';

const STORAGE_KEY = 'app_locale';

const localeMessages = {
  'zh-CN': zhCN,
  'en-US': enUS,
};

function normalizeLocale(code) {
  if (!code || code === '') {
    return 'en-US';
  }
  if (localeMessages[code]) {
    return code;
  }
  return 'en-US';
}

export function getLocale() {
  return normalizeLocale(typeof localStorage !== 'undefined' ? localStorage.getItem(STORAGE_KEY) : '');
}

/** Element UI 组件（日期选择器、分页等）与界面语言一致 */
export function syncElementUILocale() {
  const code = getLocale();
  ElementLocale.use(code === 'zh-CN' ? elementLangZhCN : elementLangEn);
}

export function setLocale(locale) {
  const next = normalizeLocale(locale);
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(STORAGE_KEY, next);
  }
  syncElementUILocale();
  return next;
}

/**
 * 以中文为键：当前语言有翻译则返回翻译，否则返回键名（中文原文）。
 * @param {string} key
 * @returns {string}
 */
export function T(key) {
  if (key === undefined || key === null) {
    return '';
  }
  const k = String(key);
  const locale = getLocale();
  const map = localeMessages[locale] || {};
  if (Object.prototype.hasOwnProperty.call(map, k) && map[k] !== '') {
    return map[k];
  }
  return k;
}

export default {
  install(Vue) {
    Vue.prototype.$T = T;
    Vue.prototype.$getLocale = getLocale;
    Vue.prototype.$setLocale = setLocale;
    Vue.filter('T', T);
    syncElementUILocale();
  },
};



// WEBPACK FOOTER //
// ./src/i18n/index.js